import { Link } from 'react-router';
import { t } from '../i18n';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl py-10 text-center">
      <h1 className="text-2xl font-bold">{t('notfound.title')}</h1>
      <p className="mt-2 text-slate-600">{t('notfound.body')}</p>
      <Link to="/" className="mt-4 inline-block font-medium text-brand-700 underline">
        {t('notfound.back')}
      </Link>
    </div>
  );
}
